import { PriceValue } from '@ca/common/types'
import { useSavedOrder } from '@order/hooks/useCartState'
import { useRemoteConfig } from 'hooks/useRemoteConfigStore'
import useSession from 'hooks/useSession'
import { useMemo } from 'react'

export const useBaseDealPackagePrice = () => {
  const config = useRemoteConfig()
  const pendingOrder = useSession((s) => s.pendingOrder)
  const baseSessionDeal = useSession((s) => s.deals.upgrade ?? s.deals.base)
  const savedOrder = useSavedOrder(pendingOrder?.savedOrderId)

  return useMemo(() => {
    if (!config) {
      return undefined
    }

    const basePackageId =
      savedOrder?.deals.base?.basePackageId ?? baseSessionDeal?.basePackageId

    if (!basePackageId) {
      return undefined
    }

    const pkg = config.packages[basePackageId]
    if (!pkg) {
      return undefined
    }

    const price = PriceValue.safe(pkg.price, config.region)
    return price > 0 ? price : undefined
  }, [config, savedOrder, baseSessionDeal])
}
